import { Component, OnInit } from '@angular/core';
import { RequestHelper } from '@shared/helper/request.helper';
import { Router } from '@angular/router';
import { NavigationConstant } from '@shared/constant/navigation.constant';
import { MessageConstant } from '@shared/constant/message.constant';
import { environment } from '@environments/environment';
import { APIConstant } from '@shared/constant/api.constant';
import { paymentVaStorage } from '@shared/storage/payment-va.storage';

// noinspection JSIgnoredPromiseFromCall,DuplicatedCode
@Component({
  selector: 'app-payment-bni-snap',
  templateUrl: './payment-bni-snap.component.html',
  styleUrls: ['./payment-bni-snap.component.css']
})
export class PaymentBniSnapComponent implements OnInit {

  virtualAccountNo: any;
  virtualAccountName: any;
  amount: any;
  isLoading = false;
  moduleName: string;
  imagePath: string;

  constructor(
    private apiService: RequestHelper,
    private storage: paymentVaStorage,
    private router: Router
  ) { }

  ngOnInit() {
    this.imagePath = this.storage.imagePath;
    this.moduleName = this.storage.moduleName;

    const inquiryResult = this.storage.inquiryResult;

    if (inquiryResult == null) {
      this.router.navigate([NavigationConstant.BNI_SNAP_INQUIRY]);
    } else {
      this.virtualAccountName = inquiryResult.virtualAccountData.virtualAccountName;
      this.virtualAccountNo = inquiryResult.virtualAccountData.virtualAccountNo;
      // tslint:disable-next-line:max-line-length
      this.amount = inquiryResult.virtualAccountData.billDetails?.[0]?.billAmount?.value || inquiryResult.virtualAccountData.totalAmount?.value;
    }
  }

  submitPayment() {
    this.isLoading = true;
    if (this.amount == null || this.amount.toString().length > 10) {
      this.isLoading = false;
      this.openDialog(MessageConstant.PAYMENT_FAILED);
    } else {
      this.storage.data.amount = this.amount;
      const inquiryResult = this.storage.inquiryResult;

      const payload = {
        virtualAccountNo: this.storage.data.virtualAccountNo,
        virtualAccountName: inquiryResult.virtualAccountData.virtualAccountName,
        paymentRequestId: inquiryResult.virtualAccountData.inquiryRequestId,
        trxId: inquiryResult.virtualAccountData.trxId,
        amount: this.amount
      };

      this.apiService.post(environment.apiUrl + APIConstant.BNI_SNAP_PAYMENT, JSON.stringify(payload))
          .subscribe(
              (data) => {
                this.storage.paymentResult = data;
                this.router.navigate([NavigationConstant.BNI_SNAP_PAYMENT_RESULT]);
              },
              () => {
                this.isLoading = false;
                this.openDialog(MessageConstant.CANNOT_PROCESS);
              }
          );
    }
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.BNI_SNAP_INQUIRY);
  }

  goBack() {
    this.router.navigate([NavigationConstant.BNI_SNAP_INQUIRY]);
  }

  home() {
    this.apiService.home();
  }
}
